<template>
    <v-container class="pa-5" fluid>
        <ReportShiftSummaryDialog
            :is-open="reportShiftSummaryDialog"
            :report-data="currentReportShiftSummary"
            :action-loading="actionLoading.approveReport"
            @on-save="updateReportShiftSummary"
            @on-close="closeReportShiftSummaryDialog"
        />
        <page-title>Rozliczenia czasu pracy</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" lg="2">
                <v-text-field
                    v-model="filters.report_object_number"
                    append-icon="mdi-magnify"
                    label="Szukaj..."
                    single-line
                    clearable
                    hide-details
                    solo
                    @keyup.enter="changeFilter"
                    @click:append="changeFilter"
                    @click:clear="clearFilter('report_object_number')"
                />
            </v-col>
            <v-col cols="12" lg="10">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" md="4" lg="3">
                            <v-autocomplete
                                v-model="filters.user_id"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Użytkownik"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                clearable
                                cache-items
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('user_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select
                                v-model="filters.group_id"
                                label="Grupa"
                                :items="generalGroups"
                                item-value
                                item-text
                                no-data-text="Nie znaleziono grupy"
                                solo
                                clearable
                                hide-details
                                @change="changeFilter()"
                                @click:clear="clearFilter('group_id')"
                            />
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.startDateTime__gte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        :disabled="!isUserSelected || !isGroupSelected"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('startDateTime__gte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    :disabled="!isUserSelected || !isGroupSelected"
                                                    @click="getForwardDate('startDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    :disabled="!isUserSelected || !isGroupSelected"
                                                    @click="getBackwardDate('startDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.startDateTime__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4" lg="2">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.startDateTime__lte"
                                        label="Data"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        :disabled="!isUserSelected || !isGroupSelected"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('startDateTime__lte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty raportu"
                                                    :disabled="!isUserSelected || !isGroupSelected"
                                                    @click="getForwardDate('startDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty raportu"
                                                    :disabled="!isUserSelected || !isGroupSelected"
                                                    @click="getBackwardDate('startDateTime__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.startDateTime__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-col cols="auto">
                <v-btn
                    text
                    x-small
                    data-sentry-label="Generuj raport"
                    :disabled="actionLoading.generateReport"
                    @click="generateShiftSummariesReport"
                >
                    <v-icon
                        v-if="!actionLoading.generateReport"
                        small
                        color="green"
                    >
                        mdi-file-excel
                    </v-icon>
                    <v-progress-circular
                        v-else
                        indeterminate
                        color="primary"
                        class="mr-1"
                        size="12"
                        width="2"
                    />
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="dailyReportsShiftSummaries"
                        :loading="dailyReportsShiftSummariesLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        :item-class="setSelectedRow"
                        name="reportsData"
                        @pagination="updatePagination"
                    >
                        <template #item.user="{item}">
                            <template v-if="item.user">
                                <template v-if="item.user.firstName && item.user.lastName">
                                    {{ item.user.firstName }} {{ item.user.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.user.username }}
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.machinesNames="{item}">
                            {{ getFirstMachineNameInList(item.machinesNames) }}

                            <v-tooltip
                                v-if="item.machinesNames.length > 1"
                                :open-delay="tooltipDelay"
                                bottom
                            >
                                <template #activator="{on}">
                                    <v-chip
                                        small
                                        class="ml-1"
                                        color="warning"
                                        v-on="on"
                                    >
                                        +{{ item.machinesNames.length - 1 }}
                                    </v-chip>
                                </template>
                                <div
                                    v-for="(machineName, index) in getMatchinesNamesWithoutFirstIndex(item.machinesNames)"
                                    :key="index"
                                >
                                    {{ machineName }}
                                </div>
                            </v-tooltip>
                        </template>
                        <template #item.startDateTime="{item}">
                            {{ formatDate(item.startDateTime) }}
                        </template>
                        <template #item.endDateTime="{item}">
                            <template v-if="item.endDateTime">
                                {{ formatDate(item.endDateTime) }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.reportedAmount="{item}">
                            {{ item.reportedAmount }}
                        </template>
                        <template #item.finishedReports="{item}">
                            {{ item.finishedReports }}
                        </template>
                        <template #item.shippedBoxes="{item}">
                            {{ item.shippedBoxes }}
                        </template>
                        <template #item.shippedWeight="{item}">
                            {{ item.shippedWeight }}
                        </template>
                        <template #item.workingTimeRatio="{item}">
                            <template v-if="item.workingTimeRatio">
                                <template v-if="item.workingTimeRatio.id === 10">
                                    <v-icon color="green">
                                        mdi-thumb-up-outline
                                    </v-icon>
                                </template>
                                <template v-else-if="item.workingTimeRatio.id === 20">
                                    <v-icon color="red">
                                        mdi-thumb-down-outline
                                    </v-icon>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.duration="{item}">
                            {{ parseDuration(item.duration) }}
                        </template>
                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex align-center">
                                <v-btn
                                    data-sentry-label="Zatwierdzenie raportu"
                                    color="success"
                                    x-small
                                    depressed
                                    :disabled="item.statusId == 20"
                                    @click="showReportShiftSummaryDialog(item)"
                                >
                                    Zatwierdź
                                </v-btn>
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Szczegóły raportu"
                                            v-on="on"
                                            @click="openReportShiftSummary(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Szczegóły raportu</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { appConfig } from '@/config.js'
import store from '@/store'
import router from '@/router'
import PageTitle from '@/components/common/PageTitle'
import ReportShiftSummaryDialog from '@/components/common/ReportShiftSummaryDialog'
import filters from '@/mixins/dataTableFilters'
import customFilters from '@/mixins/customFilters'
import pagination from '@/mixins/dataTablePagination'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'
import parse from '@/mixins/parse.js'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

let searchTimer

export default {
    name: 'DailyReportsShiftSummaries',
    components: {
        PageTitle,
        ReportShiftSummaryDialog
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        filters,
        pagination,
        customFilters,
        parse,
        dataTableClassSetter
    ],
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (!vm.filtersCleared) {
                store.dispatch('reportsAndAnalysis/reports/clearDailyReportsShiftSummaries')
                store.dispatch('reportsAndAnalysis/reports/clearUser')
                vm.users = []
            }
            vm.resetFiltersCleared()
        })
    },
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('reportsAndAnalysis/reports/clearDailyReportsShiftSummariesFilters')
            this.clearSelectedListItemId()
        }
        next()
    },
    data() {
        return {
            menuFrom: false,
            menuTo: false,
            usersSearch: null,
            usersSearchLoading: false,
            users: [],
            currentReportShiftSummary: null,
            reportShiftSummaryDialog: false,
            actionLoading: {
                approveReport: false,
                generateReport: false,
            },
            actionName: null,
            headersStart: [
                {
                    text: 'Pracownik',
                    value: 'user',
                    width: 200,
                    sortable: false,
                },
                {
                    text: 'Maszyna',
                    value: 'machinesNames',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Start',
                    value: 'startDateTime',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Stop',
                    value: 'endDateTime',
                    sortable: false,
                    align: 'center',
                }
            ],
            headersEnd: [
                {
                    text: 'Sprawność',
                    value: 'workingTimeRatio',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Zaraportowano',
                    value: 'duration',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
            headersSendings: [
                {
                    text: 'Ilość kartonów',
                    value: 'reportedBoxes',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Waga sumaryczna',
                    value: 'totalReportedWeight',
                    sortable: false,
                    align: 'center',
                }
            ],
            headersReports: [
                {
                    text: 'Nakład',
                    value: 'reportedAmount',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Suma zadań',
                    value: 'finishedReports',
                    sortable: false,
                    align: 'center',
                },
            ],
            user: {},
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        headers() {
            if (this.filters.group_id === 'nadawanie') { //sendings
                return this.headersStart.concat(this.headersSendings).concat(this.headersEnd)
            }
            if (this.filters.group_id !== 'nadawanie' && this.filters.group_id !== null) { //reports
                return this.headersStart.concat(this.headersReports).concat(this.headersEnd)
            }

            return this.headersStart.concat(this.headersEnd)
        },
        dailyReportsShiftSummaries() {
            return this.$store.state.reportsAndAnalysis.reports.dailyReportsShiftSummaries.dailyReportsShiftSummaries
        },
        dailyReportsShiftSummariesLoading() {
            return this.$store.state.reportsAndAnalysis.reports.dailyReportsShiftSummaries.dailyReportsShiftSummariesLoading
        },
        generalGroups() {
            return appConfig.reports.generalGroups
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.reports.dailyReportsShiftSummaries.dailyReportsShiftSummariesFilters
        },
        isUserSelected() {
            return typeof this.filters.user_id !== 'undefined' && this.filters.user_id !== null
        },
        isGroupSelected() {
            return typeof this.filters.group_id !== 'undefined' && this.filters.group_id !== null
        },
        selectedReportShiftSummaryId() {
            return this.$store.state.common.selectedListItemId
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''
            const startDateTime__gte = filters['startDateTime__gte']
            const startDateTime__lte = filters['startDateTime__lte']

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (!this.isUserSelected) {
                        filters['startDateTime__gte'] = ''
                        filters['startDateTime__lte'] = ''
                    } else {
                        if (item == 'startDateTime__gte') {
                            filters['startDateTime__gte'] = `${startDateTime__gte}T00:00:00Z`
                        }
                        if (item == 'startDateTime__lte') {
                            filters['startDateTime__lte'] = `${startDateTime__lte}T23:59:59Z`
                        }
                    }
                    if (item == 'startDateTime__lte') {
                        filters['startDateTime__lte'] = `${startDateTime__lte}T23:59:59Z`
                    }
                    if (item !== 'group_id') {
                        query = query.concat('&', `${item}=${filters[item]}`)
                    }
                }
            }

            return query
        }
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.$store.dispatch('administration/getUser', this.userId )
            .then(response => {
                this.user = response.data
            })
            .catch(error => {
                errorHandler(error)
            })

        if (this.savedPagination.pagination) {
            this.getDailyReportsShiftSummaries()
        }
    },
    created() {
        if (this.$store.state.reportsAndAnalysis.reports.dailyReportsShiftSummaries.user) {
            this.users.push(this.$store.state.reportsAndAnalysis.reports.dailyReportsShiftSummaries.user)
        }
    },
    methods: {
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        generateShiftSummariesReport() {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/reports/generateShiftSummariesReport', {
                query: this.filterQuery,
                userEmail: this.user.email
            })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                })
        },
        getBackwardDate(startDateTime) {
            if (Date.parse(this.filters[startDateTime]) && this.filters.user_id) {
                this.filters[startDateTime] = this.getDayBackward(this.filters[startDateTime])
                this.changeFilter()
            }
        },
        getForwardDate(startDateTime) {
            if (Date.parse(this.filters[startDateTime]) && this.filters.user_id) {
                this.filters[startDateTime] = this.getDayForward(this.filters[startDateTime])
                this.changeFilter()
            }
        },
        setSelectedRow(item) {
            if (item.id === this.selectedReportShiftSummaryId) {
                return 'isSelected'
            }
        },
        getDailyReportsShiftSummaries() {
            if (this.filters.group_id === 'nadawanie') {
                this.$store.dispatch('reportsAndAnalysis/reports/getDailyShipmentsReportsShiftSummaries', {
                    paginate: this.paginate(),
                    query: this.filterQuery
                })
                    .then(response => {
                        this.handlePaginationResponse(response)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
            if (this.filters.group_id !== 'nadawanie' && this.filters.group_id!== null) { //reports
                this.$store.dispatch('reportsAndAnalysis/reports/getDailyReportsShiftSummaries', {
                    paginate: this.paginate(),
                    query: this.filterQuery
                })
                    .then(response => {
                        this.handlePaginationResponse(response)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
        saveUser() {
            if (this.isUserSelected) {
                const user = this.users.find(item => item.id === this.filters.user_id)

                this.$store.dispatch('reportsAndAnalysis/reports/setUser', user)
            }
        },
        openReportShiftSummary(reportId) {
            this.savePagination(this.$options.name)
            this.saveFiltersCleared()
            this.setSelectedListItemId(reportId)
            this.saveUser()
            const routerName = this.filters.group_id !== 'nadawanie'
                ? 'reportingAndAnalysisReportsReportsDailyReportsShiftSummariesDetailedReports'
                : 'reportingAndAnalysisReportsReportsDailyShipmentsReportsShiftSummariesDetailedShipmentsReports'

            router.push({
                name: routerName,
                params: {
                    id: reportId
                }
            })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updateReportShiftSummary(reportShiftSummary) {
            this.$store.dispatch(`reports/${this.actionName}`, {
                ...reportShiftSummary,
                statusId: 20 //Zatwierdzony
            })
                .then(() => {
                    this.getDailyReportsShiftSummaries()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.approveReport = false
                    this.closeReportShiftSummaryDialog()
                })
        },
        showReportShiftSummaryDialog(reportShiftSummary) {
            this.actionName = this.filters.group_id === 'nadawanie' ? 'updateShipmentReportShiftSummary' : 'updateReportShiftSummary'
            this.$store.dispatch('toggleMainLoader', true)

            this.$store.dispatch('reports/getDetailedReports', {
                reportShiftSummary_id: reportShiftSummary.id
            })
                .then(response => {
                    this.currentReportShiftSummary = {
                        ...reportShiftSummary,
                        detailedReports: response.data.results
                    }

                    this.reportShiftSummaryDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$store.dispatch('toggleMainLoader', false)
                })
        },
        closeReportShiftSummaryDialog() {
            this.reportShiftSummaryDialog = false
            this.currentReportShiftSummary = null
            this.actionName = null
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisReportsReports' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('reportsAndAnalysis/reports/setDailyReportsShiftSummariesFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()
            if ((this.isUserSelected && this.isGroupSelected) || this.filters.report_object_number) {
                this.getDailyReportsShiftSummaries()
            }
            else {
                this.$store.dispatch('reportsAndAnalysis/reports/clearDailyReportsShiftSummaries')
            }
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && this.isUserSelected && this.isGroupSelected && !this.savedPagination.pagination) {
                this.getDailyReportsShiftSummaries()
            }
            this.clearPaginationPending()
        },
        getFirstMachineNameInList(machinesNames) {
            if (!machinesNames.length) {
                return '-'
            }

            return machinesNames[0]
        },
        getMatchinesNamesWithoutFirstIndex(machinesNames) {
            if (!machinesNames.length) {
                return []
            }

            return machinesNames.slice(1)
        },
    }
}

</script>